import { render, staticRenderFns } from "./UserActivities.vue?vue&type=template&id=f30fcd3e"
import script from "./UserActivities.vue?vue&type=script&lang=ts"
export * from "./UserActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports